import { ReportReason } from 'model';

export interface ReportValuesType {
	document: string;
	reason: ReportReason;
}

export const UIReportReasons = {
	offensive: 'Offensive Content',
	spam: 'Spam'
};

export interface SuspendValuesType {
	userid: string | undefined;
	suspendedUntil: string;
}

export interface SuspendTimesType {
	day: string;
	days3: string;
	week: string;
	twoweeks: string;
	month: string;
}
export const UISuspendTimes = {
	'1': '24 hours',
	'3': '3 days',
	'7': 'One week',
	'14': 'Two weeks',
	'30': 'One month'
} as const;
export const UIAdminActionsTakenLookup = {
	pausedUser: 'Temporarily Suspend User',
	blockedUser: 'Block User',
	deleted: 'Delete Content',
	invalid: 'Ignore Report'
} as const;
